module.exports = __webpack_public_path__ + "static/prize_book-1e56a3b60c08099682b3b5a477aa77ec.png";